<ph-stack gap="tight">
    <ph-toolbar *ngIf="reportName || orgName" nowrap>
        <ph-label>{{ reportName }}</ph-label>
        <ph-hint>{{ orgName }}<ng-container *ngIf="dateRange"> · {{ dateRange }}</ng-container></ph-hint>
    </ph-toolbar>
    <ph-rich-text *ngIf="tableMarkdown" size="sm" [markdown]="tableMarkdown"></ph-rich-text>
    <ph-toolbar>
        <ph-button *ngIf="csvUrl" variant="secondary" mode="filled" size="small" type="button"
                   class="report-card-download-button" icon="download-simple"
                   (click)="openDownload(csvUrl)">Export CSV</ph-button>
        <ph-button *ngIf="pdfUrl" variant="secondary" mode="filled" size="small" type="button"
                   class="report-card-download-button" icon="file-pdf"
                   (click)="openDownload(pdfUrl)">Save as PDF</ph-button>
        <ph-button *ngIf="reportsPageUrl" variant="secondary" mode="filled" size="small" type="button"
                   [routerLink]="reportsPageUrl">Open in Reports</ph-button>
        <ph-hint *ngIf="expired" class="report-card-expired">Download links expire after 24 hours. Ask Gable to run this report again.</ph-hint>
    </ph-toolbar>
</ph-stack>
